import { lazy, Suspense, ComponentProps } from 'react'
import Loader from 'components/SimpleLoader'

const MostRecent = lazy(() => import(
  /* webpackPrefetch: true */
  /* webpackChunkName: 'most-recent' */
  './MostRecent'
))

export function AsyncMostRecent(props: ComponentProps<any>) {
  return (
    <Suspense fallback={<Loader title="Loading Most Recent..." />}>
      <MostRecent {...props} />
    </Suspense>
  )
}

export default AsyncMostRecent
